module.exports = __webpack_public_path__ + "img/04.7679435b.png";